import { render, staticRenderFns } from "./pressure.vue?vue&type=template&id=85dc23ba&scoped=true&"
import script from "./pressure.vue?vue&type=script&lang=js&"
export * from "./pressure.vue?vue&type=script&lang=js&"
import style0 from "./pressure.vue?vue&type=style&index=0&id=85dc23ba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85dc23ba",
  null
  
)

export default component.exports